import { createTheme } from '@mui/material';

const theme = createTheme({
  palette: {
    primary: {
      main: '#AD235C',
      negativeMain: '#0078D4',
      affirmativeMain: '#20CC84',
      grayText: '#292E31',
      softText: '#707070',
      background: '#FFFFFF',
      background2: '#E0E0E0',
      redError: '#E52727',
      darkRed: '#8F1E20',
      disabled: '#ADADAD',
    },
    background: {
      lightGray: '#fafbfd',
      softGray: '#fcfcfc',
      mediumGray: '#f4f4f4',
    },
    text: {
      white: '#fff',
    },
    additionalColors: {
      darkMain: '#8F1E4D',
      inputBorder: '#D5D5D5',
      darkMainDisabled: '#8F8F8F',
    },
    border: {
      main: '#E0E0E0',
    },
  },
  typography: {
    fontFamily: ['Poppins', 'Raleway', 'sans-serif'].join(','),
    button: {
      textTransform: 'none',
    },
  },
});

export default theme;
